import { render } from "./CategoryFilterBar.vue?vue&type=template&id=f0389154&scoped=true"
import script from "./CategoryFilterBar.vue?vue&type=script&lang=js"
export * from "./CategoryFilterBar.vue?vue&type=script&lang=js"

import "./CategoryFilterBar.vue?vue&type=style&index=0&id=f0389154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0389154"]])

export default __exports__